import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';

/**
 * Whether the voucher tool is switched on for the lift operator of the current
 * session. Backed by the `voucherEnabled` flag maintained in the backoffice
 * ("Gutscheintool aktivieren").
 *
 * Fails closed: without a resolvable lift operator the tool counts as disabled.
 * The server enforces the same flag, so this only keeps the UI from offering
 * something the API rejects.
 */
export const useVoucherToolEnabled = (): {
    enabled: boolean;
    isLoading: boolean;
} => {
    const { liftOperatorData } = useAuthentication();
    const liftOperatorId = liftOperatorData?.liftOperatorId;
    const skip = !liftOperatorId;

    // currentData, not data: after a lift operator switch `data` still holds the
    // previous one, which would briefly unlock the tool for the wrong operator.
    const { currentData, isFetching } = useGetLiftOperatorQuery(
        { liftOperatorId },
        { skip }
    );

    return {
        enabled: currentData?.voucherEnabled === true,
        isLoading: !skip && currentData === undefined && isFetching,
    };
};
